/* Crafts by AB — Shopify Theme JS */
(function() {
  'use strict';

  // ── Mobile Menu ──────────────────────────────────────────────
  const menuToggle = document.getElementById('MobileMenuToggle');
  const mobileMenu = document.getElementById('MobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      if (open) { mobileMenu.setAttribute('hidden', ''); }
      else { mobileMenu.removeAttribute('hidden'); }
    });
    // Close on anchor click
    mobileMenu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        mobileMenu.setAttribute('hidden', '');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ── Cart Drawer ──────────────────────────────────────────────
  const cartToggle = document.getElementById('CartToggle');
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartOverlay');
  const cartClose = document.getElementById('CartClose');
  const cartCountEl = document.getElementById('CartCount');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCartItems(cart) {
    const itemsEl = document.getElementById('CartItems');
    const emptyEl = document.getElementById('CartEmpty');
    const footerEl = document.getElementById('CartFooter');
    const subtotalEl = document.getElementById('CartSubtotal');
    const loadingEl = document.getElementById('CartLoading');
    if (loadingEl) loadingEl.style.display = 'none';

    if (cart.item_count === 0) {
      if (itemsEl) itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'flex';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (cartCountEl) cartCountEl.textContent = cart.item_count;

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item">
          <a href="${item.url}" class="cart-drawer__item-image">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
          </a>
          <div class="cart-drawer__item-info">
            <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
            ${item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
            <p class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</p>
          </div>
          <div class="cart-drawer__item-actions">
            <button class="cart-drawer__remove" data-key="${item.key}" aria-label="Remove">Remove</button>
            <div class="quantity-input">
              <button class="quantity-btn" data-key="${item.key}" data-action="minus">−</button>
              <input class="quantity-input__field" type="number" value="${item.quantity}" min="0" data-key="${item.key}" style="width:2.5rem">
              <button class="quantity-btn" data-key="${item.key}" data-action="plus">+</button>
            </div>
          </div>
        </div>
      `).join('');

      // Remove buttons
      itemsEl.querySelectorAll('.cart-drawer__remove').forEach(btn => {
        btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
      });
      // Qty buttons
      itemsEl.querySelectorAll('.quantity-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const input = itemsEl.querySelector(`input[data-key="${btn.dataset.key}"]`);
          if (!input) return;
          const newQty = btn.dataset.action === 'plus' ? parseInt(input.value) + 1 : Math.max(0, parseInt(input.value) - 1);
          updateCartItem(btn.dataset.key, newQty);
        });
      });
    }
  }

  function fetchCart() {
    const loadingEl = document.getElementById('CartLoading');
    const itemsEl = document.getElementById('CartItems');
    if (loadingEl) loadingEl.style.display = 'flex';
    if (itemsEl) itemsEl.innerHTML = '';
    fetch('/cart.js')
      .then(r => r.json())
      .then(renderCartItems)
      .catch(() => { if (loadingEl) loadingEl.style.display = 'none'; });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      renderCartItems(cart);
      if (cartCountEl) cartCountEl.textContent = cart.item_count;
    });
  }

  // ── Add to Cart (product cards) ──────────────────────────────
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__atc');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.disabled = false;
      btn.innerHTML = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added`;
      openCart();
      setTimeout(() => {
        btn.innerHTML = `<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Add`;
      }, 2000);
    })
    .catch(() => { btn.disabled = false; btn.textContent = 'Error'; });
  });

  // ── Product Page ─────────────────────────────────────────────
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    // Gallery thumbs
    document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const featured = document.getElementById('ProductFeaturedImage');
        if (featured) featured.src = thumb.dataset.src;
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('product-gallery__thumb--active'));
        thumb.classList.add('product-gallery__thumb--active');
      });
    });

    // Variant selection
    const variantIdInput = document.getElementById('ProductVariantId');
    document.querySelectorAll('.option-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optionPosition;
        document.querySelectorAll(`.option-btn[data-option-position="${pos}"]`).forEach(b => b.classList.remove('option-btn--active'));
        btn.classList.add('option-btn--active');
      });
    });

    // Add to cart
    const atcBtn = document.getElementById('AddToCartBtn');
    if (atcBtn) {
      productForm.addEventListener('submit', e => {
        e.preventDefault();
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';
        const formData = new FormData(productForm);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(r => r.json())
          .then(() => {
            atcBtn.disabled = false;
            atcBtn.textContent = 'Added!';
            openCart();
            setTimeout(() => { atcBtn.textContent = atcBtn.dataset.text || 'Add to Cart'; }, 2000);
          })
          .catch(() => { atcBtn.disabled = false; atcBtn.textContent = 'Error – try again'; });
      });
    }

    // Quantity
    document.querySelectorAll('[data-qty-minus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.quantity-input').querySelector('.quantity-input__field');
        if (input) input.value = Math.max(1, parseInt(input.value) - 1);
      });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.quantity-input').querySelector('.quantity-input__field');
        if (input) input.value = parseInt(input.value) + 1;
      });
    });
  }

  // ── Inquiry Form Tabs ────────────────────────────────────────
  const tabs = document.querySelectorAll('.inquiry-tab');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('inquiry-tab--active'));
      tab.classList.add('inquiry-tab--active');
      const which = tab.dataset.tab;
      document.querySelectorAll('.inquiry-form').forEach(f => {
        if (f.dataset.inquiryForm === which) f.classList.remove('inquiry-form--hidden');
        else f.classList.add('inquiry-form--hidden');
      });
    });
  });

  // ── Collection Sort ──────────────────────────────────────────
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ── Initialise cart count ────────────────────────────────────
  fetch('/cart.js').then(r => r.json()).then(cart => {
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
  });
})();
